import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ca } from '@cian/analytics';
var getPage = function getPage(pageTypeJK) {
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    pageType: 'CardJK',
    siteType: 'desktop',
    extra: _objectSpread({
      PageTypeJK: pageTypeJK
    }, extra)
  };
};
var trackFiltersClick = function trackFiltersClick(_ref) {
  var newbuildingId = _ref.newbuildingId,
    element = _ref.element,
    pageTypeJK = _ref.pageTypeJK;
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardJK',
    action: 'Click',
    label: element,
    page: getPage(pageTypeJK),
    products: [{
      id: newbuildingId
    }]
  });
};
var trackPolygonClick = function trackPolygonClick(_ref2) {
  var newbuildingId = _ref2.newbuildingId,
    offerId = _ref2.offerId,
    pageTypeJK = _ref2.pageTypeJK;
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardJK',
    action: 'Click',
    label: 'mvk_apartment_polygon',
    page: getPage(pageTypeJK, {
      offerId: offerId
    }),
    products: [{
      id: newbuildingId
    }]
  });
};
var trackOfferLinkClick = function trackOfferLinkClick(_ref3) {
  var newbuildingId = _ref3.newbuildingId,
    offerId = _ref3.offerId,
    pageTypeJK = _ref3.pageTypeJK;
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardJK',
    action: 'Click',
    label: 'mvk_to_appartment',
    page: getPage(pageTypeJK, {
      offerId: offerId
    }),
    products: [{
      id: newbuildingId
    }]
  });
};
export var tracking = function tracking(newbuildingId, pageTypeJK) {
  var onFilterClick = function onFilterClick(element) {
    return trackFiltersClick({
      newbuildingId: newbuildingId,
      element: element,
      pageTypeJK: pageTypeJK
    });
  };
  var onPolygonClick = function onPolygonClick(offerId) {
    return trackPolygonClick({
      newbuildingId: newbuildingId,
      offerId: offerId,
      pageTypeJK: pageTypeJK
    });
  };
  var onOfferLinkClick = function onOfferLinkClick(offerId) {
    return trackOfferLinkClick({
      newbuildingId: newbuildingId,
      offerId: offerId,
      pageTypeJK: pageTypeJK
    });
  };
  return {
    onFilterClick: onFilterClick,
    onPolygonClick: onPolygonClick,
    onOfferLinkClick: onOfferLinkClick
  };
};